import { render, staticRenderFns } from "./HalvesFilter.vue?vue&type=template&id=30d819e0&"
import script from "./HalvesFilter.vue?vue&type=script&lang=js&"
export * from "./HalvesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports